import SuperFetchV2 from '../../superFetchV2';
import {
  PayMethodExhibitsFindResponse,
  PayMethodExhibitsUpdateRequest,
  PayMethodExhibitsUpdateResponse,
} from './types';

const BASE = '/pay-method-exhibits';
// 로딩·오류는 편집 화면 안에서 처리해 작성 중인 내용을 가리지 않는다.
const requestOptions = { skipFullscreenLoader: true, skipErrorModal: true };

export const payMethodExhibitApi = {
  getPayMethods: (): Promise<PayMethodExhibitsFindResponse> =>
    SuperFetchV2.get<unknown, PayMethodExhibitsFindResponse>(BASE, requestOptions),
  updatePayMethods: (body: PayMethodExhibitsUpdateRequest): Promise<PayMethodExhibitsUpdateResponse> =>
    SuperFetchV2.put<unknown, PayMethodExhibitsUpdateResponse>(BASE, body, requestOptions),
};
